import { nameOfDevice } from 'console/sortableDeviceTree/utils/devices-utils';
import { removeNulls } from 'utils';
export function replaceDevicesForTree(tree_items, devices) {
    return removeNulls(tree_items.map((tree_item) => {
        if ('Reg' in tree_item) {
            return;
        }
        if (!('children' in tree_item) && 'id' in tree_item) {
            const device = devices.find((dev) => dev.id === tree_item.id);
            if (device === undefined) {
                return;
            }
            const deviceName = nameOfDevice(device);
            return {
                title: deviceName.title,
                subtitle: deviceName.subtitle,
                device: device,
            };
        }
        if ('children' in tree_item)
            return {
                ...tree_item,
                children: replaceDevicesForTree(tree_item.children, devices),
            };
        return;
    }));
}
